import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap'
import { GenerateRandomNumber, GetUser, UpdateAdminUser } from '../../firebase/firebase'
import { useAuth } from '../../contexts/AuthContext'
import Spinner from 'react-spinkit'

export default function AdminUpdateProfile({ match }) {
    const { path } = match
    const { currentUser, logout, userRole } = useAuth()
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        description: '',
        image: '',
        email: '',

    })
    const [image, setImage] = useState('')
    const [loading, setLoading] = useState(true)
    const [validated, setValidated] = useState(false)
    const history = useHistory()

    useEffect(() => {
        GetUser(currentUser.uid).then((data) => {
            setUser({ ...user, ...data.data() })
            setImage(data.data().image)
        })
        setLoading(false)
    }, [])

    const onChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value })
        

    }

    const handleCancel = (e) => {
        history.push(`/admin`)
    }

    const handleSubmit = async (e) => {
        const form = e.currentTarget
        if (form.checkValidity() === false) {
            console.log('need val')
            e.preventDefault()
            e.stopPropagation()
        }
        setValidated(true)
        e.preventDefault()


        try {
            setLoading(true)
            let userToUpload = { ...user }
            userToUpload.imagePath = `/profiles/${userToUpload.firstName + userToUpload.lastName}`


            await UpdateAdminUser(userToUpload).then((user) => {
                history.push(`/admin`)
            })


        }

        catch (e) {
            alert(`Error " ${e.message}`)

        }
        setLoading(false)
    }

    return (
        <>
            {loading ? "Loading" :
                <Container fluid className='pt-5'>

                    <Row className="justify-content-md-center">
                        <Col lg={6}>
                            <Card>
                                <Form validated={validated} onSubmit={handleSubmit}>
                                    <Card.Header>
                                        Update Profile
                                    </Card.Header>
                                    <Card.Img variant="top" src={image} className='p-3 justify-content-center d-flex mx-auto' style={{height: '400px', width: 'auto'}} />
                                    <Form.File
                                        className='mx-5'
                                        type="file"
                                        required
                                        onChange={(e) => {
                                            if (e.target.files[0]) {
                                                console.log(e.target.files[0])
                                                setUser({ ...user, ['image']: e.target.files[0] })
                                                setImage(URL.createObjectURL(e.target.files[0]))

                                            }
                                        }}

                                    />
                                    <Card.Body>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Control

                                                    onChange={onChange}
                                                    type="text"
                                                    required
                                                    placeholder="First Name"
                                                    value={user.firstName}
                                                    name='firstName'
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Control

                                                    onChange={onChange}
                                                    type="text"
                                                    required
                                                    placeholder="Last Name"
                                                    value={user.lastName}
                                                    name='lastName'
                                                />
                                            </Col>


                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Control
                                                required
                                                onChange={onChange}
                                                type="text"
                                                placeholder="Description"
                                                value={user.description}
                                                name='description'
                                            />



                                        </Row>

                                        <Row xl={6}>
                                            <Col>
                                                <Button type="submit">Create</Button>
                                            </Col>
                                            <Col>
                                                <Button type='button' variant="secondary" onClick={handleCancel}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>

                                    </Card.Body>
                                </Form>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            }
        </>
    )
}
